import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Chip, Typography, Box, IconButton } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import dayjs from 'dayjs';
import { extractEmailName, isUnread, formatDate } from '../utils/format';

export default function MailTable({ rows, onRowClick, unified }) {
  const columns = [
    { field: 'unread', headerName: '', width: 40, renderCell: (p) => isUnread(p.row.flags) ? <FiberManualRecordIcon sx={{ color: '#3B82F6', fontSize: 12 }} /> : null },
    { field: 'from', headerName: 'From', width: 220, renderCell: (p) => <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{extractEmailName(p.row.from)}</Typography> },
    { field: 'subject', headerName: 'Subject', flex: 1, renderCell: (p) => (<Box><Typography sx={{ fontWeight: isUnread(p.row.flags) ? 700 : 400 }}>{p.row.subject || '(no subject)'}</Typography><Typography variant="caption" color="text.secondary">{p.row.snippet}</Typography></Box>) },
    { field: 'att', headerName: '', width: 48, renderCell: (p) => p.row.hasAttachments ? <AttachFileIcon /> : null },
    { field: 'date', headerName: 'Date', width: 150, renderCell: (p) => <Typography>{formatDate(p.row.date)}</Typography> },
  ];
  if (unified) columns.splice(2,0,{ field: 'mailbox', headerName: 'Mailbox', width: 140, renderCell: (p) => <Chip label={p.row.mailboxDisplay || p.row.mailboxId} size="small" /> });

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[25,50,100]}
        disableSelectionOnClick
        onRowClick={(params) => onRowClick && onRowClick(params.row)}
        getRowId={(r) => `${r.mailboxId || 'mailbox'}:${r.folder || 'folder'}:${r.uid || r.messageId || r.id}`}
        sx={{ border: 'none' }}
      />
    </div>
  );
}
